/** @jsxImportSource @emotion/react */
import React from 'react';

import {css} from '@emotion/react';
import PropTypes from 'prop-types';

import {LAYOUT, primaryBackgroundColor, proteinConcentrationColor} from '@/constants/appStyle';
import {useCycleHistoryDetailContext} from '@/contexts/CycleHistoryDetailContext';

import CycleHistoryBottomMenu from './CycleHistoryBottomMenu';

function CycleHistoryBottomMenuContainer(props) {
  // TODO isRemoteView it may good option to store it as an application context or application store
  const {isRemoteView} = props;
  const {isShowDetail} = useCycleHistoryDetailContext();

  const CycleHistoryBottomMenuStyle = css({
    height: LAYOUT.bottomMenuHeight,
    backgroundColor: primaryBackgroundColor,
    color: proteinConcentrationColor,
    alignSelf: 'flex-end',
    width: '100%',
  });

  return (
    <div
      css={CycleHistoryBottomMenuStyle}
      className={isRemoteView && !isShowDetail ? 'remoteViewProfieHistoryBottomMenu center footer' : 'center footer'}
    >
      {isShowDetail ? null : <CycleHistoryBottomMenu />}
    </div>
  );
}
CycleHistoryBottomMenuContainer.propTypes = {
  isRemoteView: PropTypes.bool,
};
CycleHistoryBottomMenuContainer.defaultProps = {
  isRemoteView: false,
};
export default React.memo(CycleHistoryBottomMenuContainer);
